import global from "@/locales/fr-CH/global";
import error403 from "@/locales/fr-CH/errors/403";
import error404 from "@/locales/fr-CH/errors/404";
import error500 from "@/locales/fr-CH/errors/500";
import error503 from "@/locales/fr-CH/errors/503";
import error504 from "@/locales/fr-CH/errors/504";
import maintenance from "@/locales/fr-CH/auth/maintenance";
import toast from "@/locales/fr-CH/toast/toast";
import login from "@/locales/fr-CH/auth/login";
import onboarding from "@/locales/fr-CH/auth/onboarding";
import loginPageSteps from "@/locales/fr-CH/loginPageSteps";
import dashboard from "@/locales/fr-CH/dashboard/dashboard";
import account from "@/locales/fr-CH/account/account";
import mailbox from "@/locales/fr-CH/account/mailbox";
import bankstatement from "@/locales/fr-CH/account/bankstatement";
import myApps from "@/locales/fr-CH/my-apps/myApps";
import about from "@/locales/fr-CH/about/about";
import contactService from "@/locales/fr-CH/about/contactService";
import salesPromotions from "@/locales/fr-CH/sales/promotions";
import brochures from "@/locales/fr-CH/sales/brochures";
import shop from "@/locales/fr-CH/shop/data";
import priceList from "@/locales/fr-CH/shop/priceList";
import staff from "@/locales/fr-CH/dashboard/staff";
import promotions from "@/locales/fr-CH/promotions";
import points from "@/locales/fr-CH/points";
import trainings from "@/locales/fr-CH/trainings/trainings";
import vouchers from "@/locales/fr-CH/vouchers/vouchers";
import generateReport from "@/locales/fr-CH/generate-report/generateReport";
import widgets from "@/locales/fr-CH/widgets/widgets";
import wholesaler from "@/locales/fr-CH/wholesaler/wholesaler";
import media from "@/locales/fr-CH/media/index";
import onlineVisibility from "@/locales/fr-CH/sales/onlineVisibility";
import fuelCalculator from "@/locales/fr-CH/sales/fuelCalculator";
import product from "@/locales/fr-CH/product/index";
import message from "@/locales/fr-CH/message/index";
import commitmentLetter from "@/locales/fr-CH/account/commitmentLetter";
import multiplicator from "@/locales/fr-CH/multiplicator";
import consents from "@/locales/fr-CH/consents/consents";
import investment from "@/locales/fr-CH/investment/data";
import kickback from "@/locales/fr-CH/kickback";

//prettier-ignore
const messages = {
  loginPageSteps: loginPageSteps.messages,
  global: global.messages,
  error403: error403.messages,
  error404: error404.messages,
  error500: error500.messages,
  error503: error503.messages,
  error504: error504.messages,
  maintenance: maintenance.messages,
  toast: toast.messages,
  login: login.messages,
  onboarding: onboarding.messages,
  dashboard: dashboard.messages,
  multiplicator: multiplicator.messages,
  account: account.messages,
  mailbox: mailbox.messages,
  myApps: myApps.messages,
  bankstatement: bankstatement.messages,
  about: about.messages,
  contactService: contactService.messages,
  salesPromotions: salesPromotions.messages,
  shop: shop.messages,
  staff: staff.messages,
  promotions: promotions.messages,
  points: points.messages,
  brochures: brochures.messages,
  trainings: trainings.messages,
  vouchers: vouchers.messages,
  generateReport: generateReport.messages,
  widgets: widgets.messages,
  wholesaler: wholesaler.messages,
  media: media.messages,
  onlineVisibility: onlineVisibility.messages,
  priceList: priceList.messages,
  fuelCalculator: fuelCalculator.messages,
  productInfo: product.messages,
  message: message.messages,
  commitmentLetter: commitmentLetter.messages,
  consents: consents.messages,
  investment: investment.messages,
  kickback: kickback.messages,
  productBrochures: {
    BDriveTitle: "Images de produits",
    BDriveLinkText: "Lien vers le portail IMAGES PRODUITS",
  },
}

export default {
  locale: "fr-CH",
  messages,
};
